import moment from "moment";

export class PdvCycleItem {
  constructor(
    private readonly referenceMonth: number,
    private readonly startPeriod: string,
    private readonly endPeriod: string,
    private readonly paymentDate: string,
    private readonly totalPaymentValue: number,
    private readonly totalCardValue: number,
    private readonly totalAdministrativeTax: number,
  ) {}

  public getReferenceMonth(): number {
    return this.referenceMonth;
  }

  public getStartPeriod(): string {
    return this.startPeriod;
  }

  public getEndPeriod(): string {
    return this.endPeriod;
  }

  public getPaymentDate(): string {
    return this.paymentDate;
  }

  public getTotalCardValue(): number {
    return this.totalCardValue;
  }

  public getTotalAdministrativeTax(): number {
    return this.totalAdministrativeTax;
  }

  public getTotalPaymentValue(): number {
    return this.totalPaymentValue;
  }

  public getReferenceMonthName(): string {
    return moment.months(this.referenceMonth - 1);
  }

  public getSellingCycle(): string {
    const options = { year: 'numeric' as const, month: 'numeric' as const, day: 'numeric' as const };

    const startDate = new Date(this.startPeriod).toLocaleString("pt-BR", options);
    const endDate = new Date(this.endPeriod).toLocaleString("pt-BR", options);
    const sellingCycle = `(${startDate} a ${endDate})`;

    return sellingCycle;
  }

  public getSanitizedPaymentDate(): string {
    const options = { year: 'numeric' as const, month: 'numeric' as const, day: 'numeric' as const };
    return new Date(this.paymentDate).toLocaleString("pt-BR", options);
  }
}
